// src/components/layouts/Footer.js
import React from 'react';
import { FaInstagram, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';
import '../../styles/layouts/_footer.scss';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="footer">
      <div className="copyright">
        <p>{t('footer.copyright')}</p>
      </div>
      <div className="social-icons">
        <a href="https://www.instagram.com/enzoopinotti/" target="_blank" rel="noopener noreferrer">
          <FaInstagram size={24} />
        </a>
        <a href="https://www.linkedin.com/in/enzo-daniel-pinotti-667270179/" target="_blank" rel="noopener noreferrer">
          <FaLinkedinIn size={24} />
        </a>
        <a href="https://wa.me/2346304036" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp size={24} />
        </a>
      </div>
    </div>
  );
};

export default Footer;
